<div class="letter-history-panel" [ngClass]="{ visible: isVisible }">
  <!-- Header -->
  <div class="panel-header">
    <div *ngIf="existingLetters && existingLetters.length > 0" class="panel-title">History of letter</div>
    <div class="close-button cross" (click)="onClosePanel()">
      <img _ngcontent-fup-c356="" style="height: 24px; width: 24px" src="assets/img/x.svg" alt="" />
    </div>
  </div>

  <!-- Content -->
  <div *ngIf="existingLetters && existingLetters.length > 0" class="panel-content">
    <!-- Latest version section -->
    <div class="latest-section">
      <div class="section-title">Latest version:</div>

      <div class="letter-card" *ngIf="existingLetters && existingLetters.length > 0">
        <div class="letter-info">
          <div class="letter-details">
            <div>
              <div class="letter-date-row">
                <span class="letter-date">{{ dateTimeAsString(existingLetters[0].createdAt) }}</span>
                <div class="letter-meta">
                  <div class="letter-status-tag" *ngIf="isNoIssuesLetter(existingLetters[0])">no issues</div>
                  <span class="letter-last-saved" *ngIf="lastCopySavedAt(existingLetters[0]) as lastSavedAt">
                    <i class="fa fa-download letter-copy-save-icon" aria-hidden="true"></i>
                    <span>{{ dateTimeAsString(lastSavedAt) }}</span>
                  </span>
                </div>
              </div>
              <div class="letter-views">
                Viewed {{ existingLetters[0].views || 0 }} time{{ existingLetters[0].views == 1 ? '' : 's' }}
              </div>
            </div>
          </div>
          <div class="divider"></div>
        </div>

        <!-- Email sent info -->
        <div class="email-info" *ngIf="existingLetters[0].sentEmail?.length > 0">
          <span class="email-sent-text"
            >Email Sent
            {{ dateTimeAsString(existingLetters[0].sentEmail[existingLetters[0].sentEmail.length - 1].sentDate) }}</span
          >
          <span class="email-actions">
            <a
              href="#"
              (click)="
                $event.preventDefault();
                previewEmail(existingLetters[0].sentEmail[existingLetters[0].sentEmail.length - 1])
              "
              class="email-link"
              >(View Email)</a
            >
            <a
              href="#"
              (click)="
                $event.preventDefault();
                downloadEmail(existingLetters[0].sentEmail[existingLetters[0].sentEmail.length - 1])
              "
              class="email-link"
              >Download Email</a
            >
          </span>
        </div>

        <!-- Customer URL Input -->
        <div class="url-input-container">
          <input class="url-input" [value]="customerUrl" (click)="copy(customerUrl); $event.target.select()" readonly />
          <div class="copy-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M13.6109 1.95312C11.7239 1.95312 9.85189 2.67311 8.41189 4.1101L6.28289 6.2351C5.89089 6.6251 5.89089 7.2501 6.28289 7.6411C6.67389 8.0311 7.30089 8.0311 7.69189 7.6411L9.82092 5.51611C11.9179 3.42311 15.3029 3.42411 17.3999 5.51611L17.4309 5.54711C19.5279 7.63911 19.5279 11.0171 17.4309 13.1101L11.5129 19.0161C10.2449 20.2801 8.23692 20.2361 6.98892 19.0431L6.92489 18.971C5.65789 17.706 5.67791 15.663 6.94491 14.398L12.7029 8.67211C13.1409 8.23511 13.8299 8.23511 14.2679 8.67211C14.7059 9.10911 14.7059 9.79709 14.2679 10.2351L8.28192 16.2331C7.88992 16.6241 7.88992 17.2801 8.28192 17.6711C8.67292 18.0611 9.32892 18.0241 9.69592 17.6721L15.7089 11.6721C16.9299 10.4541 16.9299 8.4531 15.7089 7.2351C15.0989 6.6251 14.2849 6.32812 13.4849 6.32812C12.6849 6.32812 11.8719 6.6251 11.2619 7.2351L5.3579 13.1731C5.2549 13.2761 5.17889 13.39 5.07189 13.518C3.52489 15.57 3.6369 18.5391 5.5089 20.4071C7.55891 22.4531 10.8719 22.4681 12.9219 20.4221L18.8399 14.5161C21.7199 11.6421 21.7199 6.9831 18.8399 4.1101C17.4009 2.67311 15.4979 1.95312 13.6109 1.95312Z"
                fill="#6D7275" />
            </svg>
          </div>
        </div>

        <!-- Email Events Link -->
        <div
          class="email-events-link"
          *ngIf="
            existingLetters[0]?.sentEmail?.length &&
            existingLetters[0].sentEmail[existingLetters[0].sentEmail.length - 1].sg_message_id
          ">
          <a
            [routerLink]="['/', 'inspection', 'emailEvent', 'list']"
            [queryParams]="{
              sg_message_id: existingLetters[0].sentEmail[existingLetters[0].sentEmail.length - 1].sg_message_id
            }"
            class="events-link"
            >View Email Events</a
          >
        </div>

        <!-- Action buttons -->
        <div class="action-buttons">
          <button type="button" class="btn-open-letter" (click)="openLatestLetter()">Open</button>
          <button type="button" class="btn-send-email" (click)="openSendEmail(existingLetters[0].id)">
            Send email
          </button>
        </div>
      </div>
    </div>

    <!-- Older versions section -->
    <div class="older-section" style="padding-bottom: 42px" *ngIf="existingLetters && existingLetters.length > 1">
      <div class="section-title">Older versions:</div>

      <div class="letter-card" *ngFor="let letter of existingLetters.slice(1)">
        <div class="letter-info">
          <div class="letter-details">
            <div>
              <div class="letter-date-row">
                <span class="letter-date">{{ dateTimeAsString(letter.createdAt) }}</span>
                <div class="letter-meta">
                  <div class="letter-status-tag" *ngIf="isNoIssuesLetter(letter)">no issues</div>
                  <span class="letter-last-saved" *ngIf="lastCopySavedAt(letter) as lastSavedAt">
                    <i class="fa fa-download letter-copy-save-icon" aria-hidden="true"></i>
                    <span>{{ dateTimeAsString(lastSavedAt) }}</span>
                  </span>
                </div>
              </div>
              <div class="letter-views-older">
                Viewed {{ letter.views || 0 }} time{{ letter.views == 1 ? '' : 's' }}
              </div>
            </div>
          </div>
          <div class="divider"></div>
        </div>

        <div class="info-actions-row">
          <div class="email-info" *ngIf="letter.sentEmail?.length">
            <span class="email-sent-text">
              Email Sent {{ dateTimeAsString(letter.sentEmail[letter.sentEmail.length - 1].sentDate) }}
            </span>
            <span class="email-actions">
              <a
                href="#"
                (click)="$event.preventDefault(); previewEmail(letter.sentEmail[letter.sentEmail.length - 1])"
                class="email-link"
                >(View Email)</a
              >
              <a
                href="#"
                (click)="$event.preventDefault(); downloadEmail(letter.sentEmail[letter.sentEmail.length - 1])"
                class="email-link"
                >Download Email</a
              >
            </span>
          </div>

          <button type="button" class="btn-send-email btn-open-older-letter" (click)="openLetter(letter)">Open</button>
        </div>
      </div>
    </div>

    <!-- Empty state -->
  </div>
  <div class="empty-state" *ngIf="!existingLetters || existingLetters.length === 0">
    <div class="empty-message">No letters have been generated for this inspection yet.</div>
  </div>
</div>

<!-- Send Email Modal - Outside the main panel to avoid z-index issues -->
<app-send-email-modal
  #sendEmailModal
  [customerUrl]="customerUrl"
  (onSend)="handleEmailSent($event)"
  [letterId]="letterId"
  [productType]="inspection?.location?.policy?.productType"
  [inspection]="inspection">
</app-send-email-modal>
